import * as React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
const Point = ({ className, time, airport, arrival, thin, date }) => {
    var _a;
    const theme = useTheme('DesktopFlightRoute').PointStyles;
    return (React.createElement("div", { className: cn(theme.point, {
            [theme.point_arrival]: arrival,
            [theme.point_thin]: thin
        }, className) },
        React.createElement("div", { className: theme.date__container },
            date && React.createElement("div", { className: theme.date }, date),
            React.createElement("div", { className: theme.time }, time),
            airport && (React.createElement("div", { className: theme.airport }, (_a = airport.city.name) !== null && _a !== void 0 ? _a : airport.name,
                " (",
                airport.iata,
                ")")))));
};
export default Point;
